import GlobalNav from './globalNav.component';

export default GlobalNav;
